import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PieChart from '../../../components/PieChart/PieChart';
import NoData from '../../../components/NoData/NoData';
import MeetingsStatisticsAPI from '../../../api/MeetingsStatisticsAPI';
import { inboundChannelToTranslationKeys } from '../../../shared/inboundChannelToTranslationKey';

type Props = { timeRange: { start: string; end: string } };

function BookingsInboundChannels({ timeRange }: Props) {
  const { t } = useTranslation();
  const [labels, setLabels] = useState<string[]>([]);
  const [values, setValues] = useState<number[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await MeetingsStatisticsAPI.getBookingsInboundChannels({ startTime: timeRange.start, endTime: timeRange.end });
        const rawLabels = res.data?.labels || [];
        const translatedLabels = rawLabels.map(label => t(inboundChannelToTranslationKeys(label)));
        setLabels(translatedLabels);
        setValues(res.data?.values || []);
      } catch (e) {
        setLabels([]);
        setValues([]);
      }
    };
    fetchData();
  }, [timeRange.start, timeRange.end, t]);

  if (!labels.length) return <NoData message={t('global.empty_results')} />;

  return (
    <PieChart
      title={t('stats.bookings_inbound_channels') || 'Bookings inbound channels'}
      labels={labels}
      data={values}
    />
  );
}

export default BookingsInboundChannels;


